'use client'

import * as React from 'react'
import * as LabelPrimitive from '@radix-ui/react-label'
import { cn } from "@shared/utils"
import { Label } from "./Label"
import { useFormField } from '../../hooks/useFormField'

/**
 * @group Components
 * 
 * @summary
 * <blockquote>Label component connected to a form input, automatically styled for errors.</blockquote>
 * 
 * @example
 * ```typescript
 * import { FormLabel } from '@shared/ui'
 * 
 * <FormLabel>Email Address</FormLabel>
 * ```
 */
export const FormLabel = React.forwardRef<
  React.ComponentRef<typeof LabelPrimitive.Root>,
  React.ComponentProps<typeof LabelPrimitive.Root>
>(({ className, ...props }, ref) => {
  const { error, formItemId } = useFormField()

  return (
    <Label
      ref={ref}
      className={cn(error && 'text-destructive', className)}
      htmlFor={formItemId}
      {...props}
    />
  )
})
FormLabel.displayName = 'FormLabel' 